require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/fn/array/from.js
 ** module id = 1210
 ** module chunks = 0
 **/